import React from 'react'

export default function Initial() {
  return (
    <main className={"main initial justify-center p-3 font-medium"}>
      Rome, 2014
    </main>
  )
}
